import { ColumnFilterItem } from '@/models/column-filter/column-filter.model';

export type CashierConfig = {
  country: string;
  countryName: string;
  recommendedMethods: number;
  defaultAmount: {
    depositList: CashierConfigDefaultAmountItem[];
    withdrawalList: CashierConfigDefaultAmountItem[];
  } | null;
  suggestedAmount: {
    depositList: CashierConfigSuggestedAmountItem[];
    withdrawalList: CashierConfigSuggestedAmountItem[];
    defaultList: number[];
  } | null;
  subsequentAmount?: {
    depositList: CashierConfigDefaultAmountItem[];
  } | null;
}

export const DEFAULT_CASHIER_CONFIG_ITEM: CashierConfig = {
  country: '',
  countryName: '',
  recommendedMethods: 0,
  defaultAmount: null,
  suggestedAmount: null,
};

export type CashierConfigListRequestParams = {
  sort?: string;
}

export type CashierConfigDefaultAmountItem = {
  currency: string;
  amount: number;
}

export type CashierConfigSuggestedAmountItem = {
  currency: string;
  presetAmountList: number[];
}

export enum CashierSettingsColumnProperties {
  EXPAND = 'expand',
  ID = 'id',
  COUNTRY_NAME = 'countryName',
  CURRENCY = 'currencyList',
  RECOMMENDED_METHOD_COUNT = 'recommendedMethods',
  ACTIONS = 'actions',
}

export enum CashierSettingsColumnLabels {
  EXPAND = '',
  ID = '#',
  COUNTRY_NAME = 'Country',
  CURRENCY = 'Currency',
  RECOMMENDED_METHOD_COUNT = 'Recommended methods',
  ACTIONS = 'Actions',
}

export const cashierConfigListColumns: ColumnFilterItem[] = [
  {
    label: CashierSettingsColumnLabels.EXPAND,
    value: CashierSettingsColumnProperties.EXPAND,
    width: 50,
  },
  {
    label: CashierSettingsColumnLabels.ID,
    value: CashierSettingsColumnProperties.ID,
    width: 50,
    align: 'center',
  },
  {
    label: CashierSettingsColumnLabels.COUNTRY_NAME,
    value: CashierSettingsColumnProperties.COUNTRY_NAME,
    width: 150,
    isSortable: true,
  },
  {
    label: CashierSettingsColumnLabels.CURRENCY,
    value: CashierSettingsColumnProperties.CURRENCY,
  },
  {
    label: CashierSettingsColumnLabels.RECOMMENDED_METHOD_COUNT,
    value: CashierSettingsColumnProperties.RECOMMENDED_METHOD_COUNT,
  },
  {
    label: CashierSettingsColumnLabels.ACTIONS,
    value: CashierSettingsColumnProperties.ACTIONS,
    width: 75,
    align: 'center',
  },
];

export enum CashierSettingsButtonName {
  CREATE = 'Create',
  ADD = 'Add',
  CANCEL = 'Cancel',
  CLOSE = 'Close',
  SAVE = 'Save',
  ADD_CURRENCY = 'Add currency',
  ADD_COUNTRY = 'Add country',
}
